import React, { useState, useEffect, useRef } from 'react';
import { Box, Button, Modal, IconButton, Chip, Skeleton, CircularProgress, Tooltip } from '@mui/material';
import {
    CloseSharp as CloseSharpIcon,
} from '@mui/icons-material';
import { deepCopy } from '../../app/util';
import icons from '../DynamicTable/productRestriction/svgIcons';
import './send-restrictions-product-modal.scss';
import cartData from '../DynamicTable/productRestriction/cart-data-moel.json';
import { callApiDirect, useFetchApi } from '../../hooks/useFetchApi';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { analytics } from '../../hooks/use-analytics';
import { toast } from 'react-toastify';
// Sample data
const dataRatePlanChipGroup = [1, 2, 3, 4];
const {
    uploadIcon,
    rightArrowIcon,
    greenUploadIcon,
    deleteRowIcon,
    panelToggleIcon,
    arrowDownIcon
} = icons;

function SendRestrictionsProductModal({ modalOpen, handleModalClose }) {
    const appState = useSelector((state) => state);
    const { current_property_date } = appState?.auth?.profile;

    const { app_state, ui_state } = appState?.app?.current_state;
    const { currency_symbol } = ui_state;
    const modalContentRef = useRef(null);
    const [secondLevelHeight, setSecondLevelHeight] = useState(0);
    const [openIndex, setOpenIndex] = useState(null);
    const rowRefs = useRef([]);
    const [data, setData] = useState([]);
    const asOfDate = app_state?.as_of_date;
    const cartCount = app_state?.plrDatesToPush?.length;
    const dispatch = useDispatch();

    const { as_of_date } = app_state;
    const isPastAsOfDate = moment(as_of_date).isBefore(current_property_date);

    const {
        isLoading: isCartLoading,
        isSuccess: isCartSuccess,
        data: cartInitalData,
        error: isCartError,
        refetch: callApi
    } = useFetchApi('getInitialCartTableDetails', { uiHelper: true }, 'GET', false, Boolean(modalOpen));

    const handleClose = () => {
        handleModalClose();
    }

    const [cartPushDeleteState, setCartPushDeleteState] = useState({
        isLoading: false,
        isSuccess: false,
        data: null,
        error: null,
        affectedDates: []
    });

    const pushDeleteSingleDate = async ({ action, date, affectedDataIndexes = {}, affectedDate, rate_plan_code, bucketLabel }) => {
        let method = (action === 'push') ? "POST" : "PUT";
        let { dateIndex, ratePlanIndex, ratePlanDetailIndex } = affectedDataIndexes;
        let dateString = date || data[dateIndex]?.date || "";
        dateString = dateIndex === "fullCart" ? "fullCart" : dateString;
        let ratePlanCode = "";

        //Added to handle multiple delete actions at the same time
        let extraPayload = {};
        if (date && ['delete', 'push'].includes(action) && !extraPayload[date]) {
            extraPayload[date] = { isLoading: true, action: action };
            cartPushDeleteState[date] = { isLoading: true, action: action };
            if (!cartPushDeleteState.affectedDates.includes(date)) {
                cartPushDeleteState.affectedDates.push(date)
            }
            if (dateIndex === "fullCart") {
                cartPushDeleteState.affectedDates = deepCopy(app_state.plrDatesToPush);
            }
        } else if (date && ['ratePlanDelete'].includes(action)) {
            cartPushDeleteState[date] = cartPushDeleteState[date] || {};
            cartPushDeleteState[date][rate_plan_code] = cartPushDeleteState[date][rate_plan_code] || {};
            cartPushDeleteState[date][rate_plan_code] = { isLoading: true, action: action, bucketLabel: bucketLabel };

        } else if (!date && ['delete', 'push'].includes(action)) {
            app_state.plrDatesToPush.forEach(date => {
                extraPayload[date] = { isLoading: true, action: action };
                if (dateIndex === "fullCart") {
                    cartPushDeleteState.affectedDates = deepCopy(app_state.plrDatesToPush);
                }
            });
        }
        setCartPushDeleteState({
            ...cartPushDeleteState,
            isLoading: true, isSuccess: false, data: null, error: null, action: action,
            affectedDataIndexes: affectedDataIndexes,
            date, ...extraPayload
        });
        const currDateIndex = cartPushDeleteState.affectedDates.indexOf(date);
        try {
            // setTimeout(() => {
            let cartAction = "";
            let cartAffectedData = "";
            let payloadData = { 'stayDates': [dateString] }
            switch (action) {
                case "push":
                    if (dateIndex === "fullCart") {
                        cartAction = "fullCartPushed";
                        payloadData = { 'stayDates': app_state.plrDatesToPush }
                        analytics.track("product_restriction_all_pushed", {
                            push_success: true,
                            push_type: 'manual_override',
                            data_level: 'product',
                            stay_dates_count: app_state.plrDatesToPush?.length,
                        });
                    } else {
                        cartAction = "single_date_push";
                        cartAffectedData = { date: dateString, dateData: { "test": 1 } }
                        payloadData = { 'stayDates': [dateString] }
                        analytics.track("product_restriction_date_pushed", {
                            stay_date: dateString,
                            push_success: true,
                            push_type: 'manual_override',
                            data_level: 'product',
                            pid: rate_plan_code,
                            restriction_type: bucketLabel,
                        });
                    }
                    break;
                case "ratePlanDelete":
                    bucketLabel = data[dateIndex]?.buckets[ratePlanIndex]?.label ?? "";
                    ratePlanCode = data[dateIndex]?.buckets[ratePlanIndex]?.rate_plans[ratePlanDetailIndex]?.rate_plan_code ?? "";
                    cartAction = "rateplan_remove";
                    cartAffectedData = { date: dateString }
                    payloadData = { 'stayDates': [date], 'bucket': [bucketLabel], 'rateplan': [rate_plan_code] }
                    break;
                case "delete":
                    ratePlanIndex = undefined;
                    ratePlanDetailIndex = undefined;
                    cartAction = "date_remove";
                    cartAffectedData = { date: dateString }
                    payloadData = { 'stayDates': [dateString] }
                    break;
                default:
                    cartAction = "";
            }

            let payload = { "asOfDate": asOfDate, data: payloadData, actionType: cartAction };
            const result = await callApiDirect(app_state, "singleDateDelete", payload, method);
            const { property_id, property_name, workspace_controls, primary_stay_range } = app_state;
            const formatted_stay_date = moment(date).format('YYYY-MM-DD');//dateFormat(moment(), "YYYY-MM-DD");
            if (result?.isSuccess) {
                if (!result?.data) {
                    window.analyze.track("PLR_restriction_push_failed", {
                        "selected_tile": ui_state.active_tiles.join(),
                        property_id, property_name,
                        stay_date: formatted_stay_date
                    }, {}, {
                        app_state: {
                            workspace_controls,
                        },
                        ui_state: {
                        }
                    });

                    throw new Error(result?.error || 'Request failed');
                }
                const selDateIndex = cartPushDeleteState.affectedDates.indexOf(date);
                cartPushDeleteState.affectedDates.splice(selDateIndex, 1);
                if (rate_plan_code) {
                    cartPushDeleteState[date][rate_plan_code].isLoading = false;
                } else {
                    cartPushDeleteState[date] = {};
                }
                //cartPushDeleteState[date] = {};
                setTimeout(() => {
                    setCartPushDeleteState({
                        ...cartPushDeleteState,
                        isLoading: false, isSuccess: true, data: result, error: null,
                        action: action,
                        affectedDataIndexes: affectedDataIndexes,
                        successDate: date
                    });
                }, 2000);

                let updatedDates = [];
                if (dateIndex === "fullCart") {
                    data.splice(0);

                } else if (cartAction === "single_date_push") {
                    cartAffectedData.dateData = result?.data?.data?.data[0];
                    let mainDataIndex = data.findIndex((dt) => dt.date === date);
                    data.splice(mainDataIndex, 1);

                    let plrdatesIndex = app_state.plrDatesToPush.findIndex((itm) => itm === date);
                    app_state.plrDatesToPush.splice(plrdatesIndex, 1);
                    updatedDates = deepCopy(app_state.plrDatesToPush);

                } else if (cartAction === "date_remove") {
                    let dateIdx = data.findIndex(d => d.date === dateString);
                    const cartDateIndex = app_state.plrDatesToPush.findIndex(d => d === date);
                    data.splice(dateIdx, 1);
                    app_state.plrDatesToPush.splice(cartDateIndex, 1);
                    updatedDates = deepCopy(app_state.plrDatesToPush);

                } else if (cartAction === "rateplan_remove") {

                    let dateIdx = data.findIndex(d => d.date === date);
                    let bucketIndex = -1;
                    let ratePlanIndex = -1;
                    data[dateIdx].buckets.forEach((bucket, bi) => {
                        if (bucketIndex < 0 && bucket.rate_plans) {
                            ratePlanIndex = bucket.rate_plans.findIndex((rp, rpi) => {
                                if (rp.rate_plan_code === rate_plan_code) {
                                    bucketIndex = bi;
                                    return true;
                                }
                            });
                        }
                    });
                    if (bucketIndex > -1 && ratePlanIndex > -1) {
                        data[dateIdx].buckets[bucketIndex].rate_plans.splice(ratePlanIndex, 1);
                    }
                    if (data[dateIdx].buckets[bucketIndex].rate_plans.length === 0) {
                        data[dateIdx].buckets.splice(ratePlanIndex, 1);
                    }
                    if (data[dateIdx].buckets.length === 0) {
                        data.splice(dateIdx, 1);
                    }
                    const dateData = result.data.data.cart_data[0];
                    data[dateIdx].badge_count = dateData.badge_count;
                    data[dateIdx].threshold = dateData.threshold;

                    const bucketLabel = data[dateIdx].buckets[bucketIndex].label
                    const bucketData = result.data.data.data[0].buckets.find(b => b.label === bucketLabel);
                    if (bucketData && data[dateIdx] && data[dateIndex]?.buckets[bucketIndex] && data[dateIndex]?.buckets[bucketIndex].label === bucketLabel) {
                        data[dateIndex].buckets[bucketIndex].badge_count = bucketData.badge_count;
                    }

                    const ratePlanDetailData = bucketData.rate_plans.filter(rp => rp.rate_plan_code === ratePlanCode)[0];

                    cartAffectedData['dateData'] = dateData;
                    cartAffectedData['bucketData'] = bucketData;
                    cartAffectedData['ratePlanDetailData'] = ratePlanDetailData;
                    updatedDates = app_state.plrDatesToPush.map(date => date);

                } else {
                    if (dateIndex !== undefined && ratePlanIndex === undefined && ratePlanDetailIndex === undefined) {
                        data.splice(dateIndex, 1);
                        const cartDateIndex = app_state.plrDatesToPush.findIndex(d => d === date);
                        app_state.plrDatesToPush.splice(cartDateIndex, 1);
                        setOpenIndex(-1);
                    }
                    else {
                        data[dateIndex].buckets[ratePlanIndex].rate_plans.splice(ratePlanDetailIndex, 1);
                        if (data[dateIndex].buckets[ratePlanIndex].rate_plans.length === 0) {
                            data[dateIndex].buckets.splice(ratePlanIndex, 1);
                        }
                        if (data[dateIndex].buckets.length === 0) {
                            data.splice(dateIndex, 1);
                        }
                        const dateData = result.data.data.cart_data[0];
                        data[dateIndex].badge_count = dateData.badge_count;
                        data[dateIndex].threshold = dateData.threshold;

                        const bucketData = result.data.data.data[0].buckets.filter(b => b.label === bucketLabel)[0];
                        if (data[dateIndex] && data[dateIndex].buckets && data[dateIndex].buckets[ratePlanIndex] && data[dateIndex].buckets[ratePlanIndex].label === bucketLabel) {
                            data[dateIndex].buckets[ratePlanIndex].badge_count = bucketData.badge_count;
                        }

                        const ratePlanDetailData = bucketData.rate_plans.filter(rp => rp.rate_plan_code === ratePlanCode)[0];

                        cartAffectedData['dateData'] = dateData;
                        cartAffectedData['bucketData'] = bucketData;
                        cartAffectedData['ratePlanDetailData'] = ratePlanDetailData;
                        updatedDates = app_state.plrDatesToPush.map(date => date);
                    }
                }
                //  if(updatedDates?.length === 0){
                //     ui_state.sendRestrictionsModalOpen = false;
                // }
                setData(deepCopy([...data]));
                dispatch({
                    type: "UPDATE_STATE",
                    payload: {
                        app_state: {
                            plrDatesToPush: updatedDates,
                            plrCartUpdate: {
                                axn: cartAction,
                                data: cartAffectedData
                            }
                        },
                        ui_state: {
                            sendRestrictionsModalOpen: Boolean(updatedDates?.length)
                        }
                    }
                });

                //}, 2000);
            }
        } catch (err) {
            if (dateIndex === "fullCart") {
                cartPushDeleteState?.affectedDates.forEach((dt) => {
                    if (cartPushDeleteState[dt]) cartPushDeleteState[dt].isLoading = false;
                })
                cartPushDeleteState.affectedDates = [];
            } else {
                if (rate_plan_code && cartPushDeleteState[date]
                    && cartPushDeleteState[date][rate_plan_code]
                    && cartPushDeleteState[date][rate_plan_code].bucketLabel === bucketLabel
                ) {
                    cartPushDeleteState[date][rate_plan_code].isLoading = false;
                    //cartPushDeleteState.affectedDates.splice(currDateIndex, 1);
                } else {
                    cartPushDeleteState[date].isLoading = false;
                    cartPushDeleteState.affectedDates.splice(currDateIndex, 1);
                }
            }
            setCartPushDeleteState({
                ...cartPushDeleteState, isLoading: false, isSuccess: false,
                data: null, error: err,
                errorDate: date
            });
            toast.dismiss();
            toast.error(err.toString(), {
                position: "top-right"
            });
        }
    }


    const removeRatePlanDetails = (dateIndex, ratePlanIndex, ratePlanDetailIndex, date, rate_plan_code, bucketLabel) => {
        const newData = deepCopy([...data]);
        const dateObj = newData[dateIndex];
        // const ratePlanObj = dateObj.buckets[ratePlanIndex];
        const ratePlanObj = dateObj.buckets.find((bucket) => {
            const indexOfRatePlan = bucket.rate_plans.findIndex((plan) => plan.rate_plan_code === rate_plan_code);
            if (indexOfRatePlan > -1) {
                bucket.rate_plans.splice(indexOfRatePlan, 1);
                return bucket;
            }
        });
        // debugger;

        // const newState = cartPushDeleteState[date] || {};
        // newState[date] = newState[date] || {};
        // newState[date][rate_plan_code] = newState[date][rate_plan_code] || {isLoading: true};

        // setCartPushDeleteState({
        //     ...cartPushDeleteState,
        //     ...newState
        // });

        // ratePlanObj.rate_plans.splice(ratePlanDetailIndex, 1);
        let removedLevel = 'ratePlan'

        // If no more rate plans left in the bucket, remove the entire bucket
        if (ratePlanObj && ratePlanObj.rate_plans.length === 0) {
            dateObj.buckets.splice(ratePlanIndex, 1);
            removedLevel = removedLevel + '_bucket';
        }

        // If no more buckets left for the date, remove the entire date entry
        if (dateObj.buckets.length === 0) {
            setOpenIndex(-1);
            newData.splice(dateIndex, 1);
            removedLevel = removedLevel + '_stayDates';
        }

        let affectedDataIndexes = {
            dateIndex,
            ratePlanIndex,
            ratePlanDetailIndex
        }

        switch (removedLevel) {
            case "ratePlan":
            case "ratePlan_bucket":
                pushDeleteSingleDate({ action: 'ratePlanDelete', affectedDataIndexes: affectedDataIndexes, date, rate_plan_code, bucketLabel });
                break;
            default:
                pushDeleteSingleDate({ action: 'delete', affectedDataIndexes: affectedDataIndexes, date, rate_plan_code, bucketLabel });
        }
    }


    const handleDetailsOpen = (index) => {
        setOpenIndex((prev) => (prev === index ? -1 : index));
    }

    useEffect(() => {
        // if (openIndex === null) return;
        setOpenIndex(-1);
        if (!modalOpen) return;
        const updateHeight = () => {
            const ref = modalContentRef.current;
            if (ref) {
                const height = ref.offsetHeight;
                console.log("modalContentRef.current.offsetHeight", height);
                setSecondLevelHeight(height - 128);
            }
        };
        // Delay to ensure DOM is painted
        requestAnimationFrame(updateHeight);

        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, [modalOpen]);

    useEffect(() => {
        if (rowRefs.current[openIndex]) {
            setTimeout(() => {
                rowRefs.current[openIndex].scrollIntoView({ behavior: 'auto', block: 'start' });
            }, 300);
        }
    }, [openIndex]);

    useEffect(() => {
        if (isCartSuccess && cartInitalData) {
            setData(cartInitalData.data);
        }
    }, [isCartSuccess, cartInitalData]);

    useEffect(() => {
        if (['processing', 'active'].includes(app_state.plrRowCalcStatus)) {
            setData([]);
        }
    }, [app_state.plrRowCalcStatus]);
    //   if (isCartLoading && modalOpen) return (<DetailsLoader />);

    let confirmAllChangesBtn = <Button
        className="confirm-btn"
        variant="outlined"
        size="small"
        color="white"
        onClick={() => pushDeleteSingleDate({ action: 'push', affectedDataIndexes: { dateIndex: 'fullCart' } })}
    >
        {uploadIcon} Confirm All Changes
    </Button>;

    if (isPastAsOfDate) {
        confirmAllChangesBtn = <Tooltip title="Please set the “As of date” to the current date to take any action." arrow>
            <Button
                className="confirm-btn"
                variant="outlined"
                size="small"
                color="white"
            >
                {uploadIcon} Confirm All Changes
            </Button>
        </Tooltip>;
    }

    return (
        <Modal
            className="popup-modal-wrap "
            open={modalOpen}
            onClose={() => {
                handleClose();
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box className='popup-modal send-restrictions-product-modal'>
                <Box className='modal-titlebar'>
                    <div className='title'>Restrictions - Review and Update</div>

                    {(data?.length ?? 0) > 0 && confirmAllChangesBtn}
                    <IconButton
                        onClick={() => {
                            handleClose();
                        }}
                        sx={{
                            minWidth: 'auto', position: 'absolute', top: -12, right: -12, width: 24, height: 24,
                            p: '7px', borderRadius: '50%', border: '1px solid #ccc',
                            boxShadow: '0 0 4px #000', background: '#000', color: '#FFF',
                            fontSize: 10, '&:hover': { backgroundColor: '#000' }
                        }}
                    >
                        <CloseSharpIcon fontSize='small' />
                    </IconButton>
                </Box>



                <Box id='mexHeightRef' className='modal-content' ref={modalContentRef}>
                    <Box className='sr-first-level'>
                        <Box className='default-item fl-title'>
                            <div className='date'>Date</div>
                            <div className='threshold'>Threshold ({currency_symbol})</div>
                            <div className='actions'>Actions</div>
                        </Box>
                        <Box className='fl-scroller'>
                            {data && data.length > 0 ? (
                                data?.map((dateItem, index) => (
                                    <Box
                                        key={index}
                                        className={`first-level-row ${openIndex === index ? 'open-panel' : ''}`}
                                        ref={el => rowRefs.current[index] = el}
                                    >
                                        <FirstLevelDataRow
                                            index={index}
                                            isOpen={openIndex === index}
                                            // onToggle={() => setOpenIndex(prev => (prev === index ? -1 : index))}
                                            onToggle={() => handleDetailsOpen(index)}
                                            dateData={dateItem}
                                            pushDeleteSingleDate={pushDeleteSingleDate}
                                            cartPushDeleteState={cartPushDeleteState}
                                            isPastAsOfDate={isPastAsOfDate}
                                        />
                                        <FirstLevelDataPanel
                                            isOpen={openIndex === index}
                                            secondLevelHeight={secondLevelHeight}
                                            dateData={dateItem}
                                            removeRatePlanDetails={removeRatePlanDetails}
                                            dateIndex={index}
                                            cartPushDeleteState={cartPushDeleteState}
                                        />
                                    </Box>
                                ))
                            ) : isCartLoading ? (
                                <InitialLoader rowsCount={cartCount} />


                            ) : (
                                <Box key="no-item" style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "100px",
                                    color: "#666",
                                    fontSize: "16px",
                                    fontWeight: 500,
                                    textAlign: "center",
                                    backgroundColor: "#f9f9f9",
                                    borderRadius: "8px",
                                }}>
                                    <div>Cart is empty!</div>
                                </Box>
                            )}

                        </Box>
                    </Box>
                </Box>



            </Box>
        </Modal>
    );
}

const FirstLevelDataRow = ({ index, isOpen, onToggle, dateData, pushDeleteSingleDate, cartPushDeleteState, isPastAsOfDate }) => {
    const { date } = dateData;

    let pushIconButton = <IconButton className='action-btn' onClick={() => pushDeleteSingleDate({ date, action: 'push', affectedDataIndexes: { dateIndex: index }, affectedDate: dateData.date })}>{greenUploadIcon}</IconButton>;
    // let pushIconButton = <IconButton disabled={cartPushDeleteState && cartPushDeleteState[date] && cartPushDeleteState[date]?.isLoading} className='action-btn' onClick={() => pushDeleteSingleDate({ date, action: 'push', affectedDataIndexes: { dateIndex: index }, affectedDate: dateData.date })}>{greenUploadIcon}</IconButton>;
    let deleteIconButton = <IconButton className='action-btn' onClick={() => pushDeleteSingleDate({ action: 'delete', date, affectedDataIndexes: { dateIndex: index } })}>{deleteRowIcon}</IconButton>;
    // let deleteIconButton = <IconButton disabled={cartPushDeleteState && cartPushDeleteState[date] && cartPushDeleteState[date]?.isLoading} className='action-btn' onClick={() => pushDeleteSingleDate({ action: 'delete', date, affectedDataIndexes: { dateIndex: index } })}>{deleteRowIcon}</IconButton>;
    if (isPastAsOfDate) {
        pushIconButton = <Tooltip title="Please set the “As of date” to the current date to take any action." arrow>
            <IconButton className='action-btn'>{greenUploadIcon}</IconButton>
        </Tooltip>;
        deleteIconButton = <Tooltip title="Please set the “As of date” to the current date to take any action." arrow>
            <IconButton className='action-btn'>{deleteRowIcon}</IconButton>
        </Tooltip>;
    }
    return (<Box className='default-item fl-content'>
        <div className='date badge-container' onClick={onToggle}>
            <div className='badge-title'>
                {moment(dateData?.date).format('ddd, MMM DD, YYYY')}
                <span className='badge-count'>{dateData?.badge_count}</span>
            </div>
            <IconButton className={`panel-toggle ${isOpen ? 'arrow-up' : 'arrow-down'}`} size="small">
                {arrowDownIcon}
            </IconButton>
        </div>
        <div className='threshold'>{dateData?.threshold?.pre}{rightArrowIcon}{dateData?.threshold?.current}</div>
        <div className='actions'>
            {cartPushDeleteState && cartPushDeleteState[date]?.isLoading
                && cartPushDeleteState?.affectedDates.includes(date)
                && cartPushDeleteState && cartPushDeleteState[date]?.action === 'push' ? (
                <Box sx={{ height: "18px", width: "18px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <CircularProgress size="12px" />
                </Box>
            ) : pushIconButton}

            {cartPushDeleteState && cartPushDeleteState[date]?.isLoading && cartPushDeleteState?.affectedDates.includes(date) && cartPushDeleteState[date]?.action === 'delete' ? (
                <Box sx={{ height: "18px", width: "18px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <CircularProgress size="12px" />
                </Box>
            ) : deleteIconButton}

        </div>
    </Box>
    )
};


const FirstLevelDataPanel = ({ isOpen, secondLevelHeight, dateData, dateIndex, removeRatePlanDetails, cartPushDeleteState }) => {
    const scrollRef = useRef(null);
    const [scrollShadow, setScrollShadow] = useState({ top: false, bottom: false });
    const handleScroll = () => {
        const el = scrollRef.current;
        if (!el) return;

        const { scrollTop, scrollHeight, clientHeight } = el;

        const hasTop = scrollTop > 0;
        const hasBottom = scrollTop + clientHeight < scrollHeight - 1;

        setScrollShadow({ top: hasTop, bottom: hasBottom });
    };


    let [expendedDate, setExpendedDate] = useState(null);
    const {
        isLoading: isDetailsLoading,
        isSuccess: isDetailsSuccess,
        data: detailsData,
        error: detailsError,
        refetch: callApi
    } = useFetchApi('getCartDateDetails', { uiHelper: true, stayDate: moment(expendedDate).format('YYYY-MM-DD') }, 'GET', false, Boolean(expendedDate));

    const didFetch = useRef(false);

    useEffect(() => {
        // if (isOpen && !didFetch.current) {
        if (isOpen) {
            didFetch.current = true;
            setExpendedDate(dateData.date);

            let testBucket = {
                "buckets": [
                    {
                        "label": dateData?.date + "Premium Rate Plan",
                        "details_open": false,
                        "badge_count": 12,
                        "rate_plans": [
                            {
                                "rate_plan_code": "RIV1-STD-KG",
                                "label": "test Non-Refundable Advance Purchase with Breakfast and Dinner Included",
                                "rooms_summary": [
                                    {
                                        "room_type_code": "RIV2",
                                        "restrictions": {
                                            "prev": ["MX 1"],
                                            "current": ["CTA", "CLS"]
                                        }
                                    },
                                    {
                                        "room_type_code": "RIV1",
                                        "restrictions": {
                                            "prev": ["MX 4", "MX 1"],
                                            "current": ["CTD"]
                                        }
                                    },
                                    {
                                        "room_type_code": "RIV3",
                                        "restrictions": {
                                            "prev": ["MIN 4", "MX 1"],
                                            "current": ["CTD", "MX 2"]
                                        }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "label": "0-10% Discount",
                        "details_open": false,
                        "badge_count": 2,
                        "rate_plans": [
                            {
                                "rate_plan_code": "RIV1-STD-KG",
                                "label": "Non-Refundable Advance Purchase with Breakfast and Dinner Included",
                                "rooms_summary": [
                                    {
                                        "room_type_code": "RIV1",
                                        "restrictions": {
                                            "prev": ["MX 1"],
                                            "current": ["CTA", "CLS"]
                                        }
                                    },
                                    {
                                        "room_type_code": "RIV1",
                                        "restrictions": {
                                            "prev": ["MX 4", "MX 1"],
                                            "current": ["CTD"]
                                        }
                                    },
                                    {
                                        "room_type_code": "RIV1",
                                        "restrictions": {
                                            "prev": ["MIN 4", "MX 1"],
                                            "current": ["CTD", "MX 2"]
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            };
            // console.log(isDetailsSuccess);
            if (isDetailsSuccess) {
                // console.log(detailsData.data);
                dateData.buckets = detailsData.data;
                // debugger;
            }
        }
    }, [isOpen, dateIndex, isDetailsSuccess]);


    if (isDetailsLoading) return (<DetailsLoader />);

    return (
        <Box
            mb={isOpen ? 1 : 0}
            className={`first-level-panel ${scrollShadow.top ? 'has-scroll-top' : ''} ${scrollShadow.bottom ? 'has-scroll-bottom' : ''}`}
            style={{
                //height: isOpen ? `${secondLevelHeight}px` : '0px',
                maxHeight: isOpen ? `${secondLevelHeight}px` : '0px',
                transition: 'height 0.3s ease',
                overflow: 'hidden'
            }}
        >
            <Box
                className='sr-second-level'
                ref={scrollRef}
                onScroll={handleScroll}
                //style={{ height: '100%', overflowY: 'auto' }}
                style={{ maxHeight: isOpen ? `${secondLevelHeight}px` : '0px', overflowY: 'auto' }}
            >
                <SecondLevelDataPanel dateData={dateData} dateIndex={dateIndex} removeRatePlanDetails={removeRatePlanDetails} cartPushDeleteState={cartPushDeleteState} />
            </Box>
        </Box>
    );
};

const SecondLevelDataPanel = ({ dateData, dateIndex, removeRatePlanDetails, cartPushDeleteState }) => (
    <>
        {dateData?.buckets?.length > 0 ? (
            dateData.buckets.map((bucketItem, ratePlanIndex) => (
                <RatePlanBucket
                    key={ratePlanIndex}
                    date={dateData.date}
                    bucketItem={bucketItem}
                    dateIndex={dateIndex}
                    ratePlanIndex={ratePlanIndex}
                    removeRatePlanDetails={removeRatePlanDetails}
                    cartPushDeleteState={cartPushDeleteState}
                />
            ))
        ) : (
            <div className='empty-message'>
                No changes were made to any restrictions.
            </div>
        )}
    </>

    // <>
    //     {dateData?.buckets?.map((bucketItem, ratePlanIndex) => (
    //         <RatePlanBucket key={ratePlanIndex} date={dateData.date} bucketItem={bucketItem} dateIndex={dateIndex} ratePlanIndex={ratePlanIndex} removeRatePlanDetails={removeRatePlanDetails} cartPushDeleteState={cartPushDeleteState} />
    //     ))}
    // </>
);

const RatePlanBucket = ({ date, bucketItem, dateIndex, ratePlanIndex, removeRatePlanDetails, cartPushDeleteState }) => (
    <>
        <Box className='default-item sl-title'>
            <div className='date badge-container'>
                <span className='badge-title'>
                    {bucketItem?.label}
                    {/* <span className='badge-count'>{bucketItem?.badge_count}</span> */}
                </span>
            </div>
        </Box>
        <Box className='sl-content-panel'>
            {bucketItem?.rate_plans.map((ratePlanDetailItem, rate_plan_detail_index) => (
                <RatePlanDetailRow
                    key={rate_plan_detail_index}
                    ratePlanDetail={ratePlanDetailItem}
                    dateIndex={dateIndex}
                    removeRatePlanDetails={removeRatePlanDetails}
                    ratePlanIndex={ratePlanIndex}
                    ratePlanDetailIndex={rate_plan_detail_index}
                    cartPushDeleteState={cartPushDeleteState}
                    date={date}
                    bucketLabel={bucketItem.label}
                />
            ))}
        </Box>
    </>
);

const RatePlanDetailRow = ({ ratePlanDetail, dateIndex, removeRatePlanDetails, ratePlanIndex, ratePlanDetailIndex, cartPushDeleteState, date, bucketLabel }) => {
    const { rate_plan_code } = ratePlanDetail;

    return <Box className='default-item sl-content'>
        <div className='plan-details'>
            {/* {ratePlanDetail.label} - {ratePlanDetail.rate_plan_code} */}
            <Tooltip arrow title={ratePlanDetail?.label}>{ratePlanDetail.rate_plan_code}</Tooltip>
        </div>
        <div className='rooms-chip'>
            {ratePlanDetail?.rooms_summary.map((ratePlanItem, index) => (
                <RatePlanChip key={index} ratePlanItem={ratePlanItem} />
            ))}
        </div>
        <div className='actions'>
            {
                // cartPushDeleteState?.isLoading
                cartPushDeleteState[date]
                    && cartPushDeleteState[date][rate_plan_code]
                    && cartPushDeleteState[date][rate_plan_code]?.isLoading
                    && cartPushDeleteState[date][rate_plan_code].bucketLabel === bucketLabel ? (
                    // && cartPushDeleteState?.affectedDataIndexes?.dateIndex === dateIndex 
                    // && cartPushDeleteState?.affectedDataIndexes?.ratePlanIndex === ratePlanIndex 
                    // && cartPushDeleteState?.affectedDataIndexes?.ratePlanDetailIndex === ratePlanDetailIndex ? (
                    <CircularProgress size="12px" />
                ) : (
                    // <IconButton
                    //     onClick={() => removeRatePlanDetails(dateIndex, ratePlanIndex, ratePlanDetailIndex, date, rate_plan_code, bucketLabel)}
                    //     className='action-btn'>
                    //     {deleteRowIcon}
                    // </IconButton>
                    <></>
                )}
        </div>
    </Box>
};

const RatePlanChip_x = (ratePlanItem) => {
    return (<Box className='rate-plan-chip'>
        <span className='chip-code'>{ratePlanItem.rate_plan_code}</span>
        <Chip className="restrictions-chips chip-cls removed" label="CLS" variant="outlined" />
        <Chip className="restrictions-chips chip-mx 2" label="MX 2" variant="outlined" />
        <Chip className="restrictions-chips chip-mn 1" label="MN 1" variant="outlined" />
    </Box>
    )
};


const RatePlanChip = ({ ratePlanItem }) => {
    // helper to map restriction to chip class
    const getChipClass = (restriction) => {
        const code = restriction.split(" ")[0].toLowerCase(); // "MX 2" -> "mx"
        return `chip-${code}`;
    };

    return (
        <Box className="rate-plan-chip">
            <span className="chip-code">{ratePlanItem?.room_type_code}</span>

            {/* Previous restrictions (removed) */}
            {/* {ratePlanItem.restrictions?.prev?.map((res, idx) => ( */}
            {ratePlanItem.restrictions?.pre?.map((res, idx) =>
                res?.toLowerCase().replace(/\s+/g, "") === "mn1"
                    ? null
                    :
                    (
                        <Chip
                            key={`prev-${idx}`}
                            className={`restrictions-chips ${getChipClass(res)} removed`}
                            label={res}
                            variant="outlined"
                        />
                    ))}

            {/* Current restrictions */}
            {/* {ratePlanItem.restrictions?.current?.map((res, idx) => (
                <Chip
                    key={`current-${idx}`}
                    className={`restrictions-chips ${getChipClass(res)}`}
                    label={res+" ppp"}
                    variant="outlined"
                />
            ))} */}
            {ratePlanItem.restrictions?.current?.map((res, idx) =>
                res?.toLowerCase().replace(/\s+/g, "") === "mn1"
                    ? null
                    : (
                        <Chip
                            key={`current-${idx}`}
                            className={`restrictions-chips ${getChipClass(res)}`}
                            label={res}
                            variant="outlined"
                        />
                    )
            )}
        </Box>
    );
};


// import { Box, Chip, IconButton, Skeleton } from "@mui/material";
const InitialLoader = ({ rowsCount = 1 }) => (
    <>
        {Array.from({ length: rowsCount }).map((_, idx) => (
            <Box className="default-item fl-content" key={idx}>
                <div className="date badge-container">
                    <div className="badge-title">
                        <Skeleton variant="text" width={120} height={24} />
                        {/* <span className="badge-count">
                            <Skeleton
                                variant="rectangular"
                                width={20}
                                height={11}
                                style={{ borderRadius: 16 }}
                            />
                        </span> */}
                    </div>
                </div>
                <div className="threshold">
                    <Skeleton variant="text" width={50} height={24} />
                    <Skeleton variant="text" width={50} height={24} />
                </div>
                <div className="actions">
                    <Skeleton
                        variant="rectangular"
                        width={15}
                        height={15}
                        style={{ borderRadius: 16 }}
                    />
                    <Skeleton
                        variant="rectangular"
                        width={15}
                        height={15}
                        style={{ borderRadius: 16 }}
                    />
                </div>
            </Box>
        ))}
    </>
);


const DetailsLoader = () => (<>
    <Box>
        {/* Title with badge */}
        <Box className="default-item sl-title">
            <div className="date badge-container">
                <span className="badge-title">
                    <Skeleton variant="text" width={120} height={24} />
                    {/* <span className="badge-count"></span> */}
                </span>
            </div>
        </Box>

        {/* Content panel */}
        <Box className="sl-content-panel">
            <Box className="default-item sl-content" sx={{ width: "90%", gap: "10px", padding: "4px 8px !important" }}>
                <div className="plan-details">
                    <Skeleton variant="text" width={250} height={24} />
                </div>

                {/* Fake chips */}
                <div className="rooms-chip">
                    <Box className="rate-plan-chip">
                        <span className="chip-code" style={{ width: "40px" }}></span>

                        {/* Loader skeletons for chips */}
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                    </Box>
                </div>
                <div className="rooms-chip">
                    <Box className="rate-plan-chip">
                        <span className="chip-code" style={{ width: "40px" }}></span>

                        {/* Loader skeletons for chips */}
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16 }}
                        />
                    </Box>
                </div>
                <div className="rooms-chip">
                    <Box className="rate-plan-chip">
                        <span className="chip-code" style={{ width: "40px" }}></span>

                        {/* Loader skeletons for chips */}
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                    </Box>
                </div>
            </Box>
        </Box>
        <Box className="sl-content-panel">
            <Box className="default-item sl-content" sx={{ width: "90%", gap: "10px", padding: "4px 8px !important" }}>
                <div className="plan-details">
                    <Skeleton variant="text" width={250} height={24} />
                </div>

                {/* Fake chips */}
                <div className="rooms-chip">
                    <Box className="rate-plan-chip">
                        <span className="chip-code" style={{ width: "40px" }}></span>

                        {/* Loader skeletons for chips */}
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                    </Box>
                </div>
                <div className="rooms-chip">
                    <Box className="rate-plan-chip">
                        <span className="chip-code" style={{ width: "40px" }}></span>

                        {/* Loader skeletons for chips */}
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16 }}
                        />
                    </Box>
                </div>
                <div className="rooms-chip">
                    <Box className="rate-plan-chip">
                        <span className="chip-code" style={{ width: "40px" }}></span>

                        {/* Loader skeletons for chips */}
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                    </Box>
                </div>
            </Box>
        </Box>
    </Box>

    <Box>
        {/* Title with badge */}
        <Box className="default-item sl-title">
            <div className="date badge-container">
                <span className="badge-title">
                    <Skeleton variant="text" width={120} height={24} />
                    {/* <span className="badge-count"></span> */}
                </span>
            </div>
        </Box>

        {/* Content panel */}
        <Box className="sl-content-panel">
            <Box className="default-item sl-content" sx={{ width: "90%", gap: "10px", padding: "4px 8px !important" }}>
                <div className="plan-details">
                    <Skeleton variant="text" width={250} height={24} />
                </div>

                {/* Fake chips */}
                <div className="rooms-chip">
                    <Box className="rate-plan-chip">
                        <span className="chip-code" style={{ width: "40px" }}></span>

                        {/* Loader skeletons for chips */}
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                    </Box>
                </div>
                <div className="rooms-chip">
                    <Box className="rate-plan-chip">
                        <span className="chip-code" style={{ width: "40px" }}></span>

                        {/* Loader skeletons for chips */}
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16 }}
                        />
                    </Box>
                </div>
                <div className="rooms-chip">
                    <Box className="rate-plan-chip">
                        <span className="chip-code" style={{ width: "40px" }}></span>

                        {/* Loader skeletons for chips */}
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                    </Box>
                </div>
            </Box>
        </Box>
        <Box className="sl-content-panel">
            <Box className="default-item sl-content" sx={{ width: "90%", gap: "10px", padding: "4px 8px !important" }}>
                <div className="plan-details">
                    <Skeleton variant="text" width={250} height={24} />
                </div>

                {/* Fake chips */}
                <div className="rooms-chip">
                    <Box className="rate-plan-chip">
                        <span className="chip-code" style={{ width: "40px" }}></span>

                        {/* Loader skeletons for chips */}
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                    </Box>
                </div>
                <div className="rooms-chip">
                    <Box className="rate-plan-chip">
                        <span className="chip-code" style={{ width: "40px" }}></span>

                        {/* Loader skeletons for chips */}
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16 }}
                        />
                    </Box>
                </div>
                <div className="rooms-chip">
                    <Box className="rate-plan-chip">
                        <span className="chip-code" style={{ width: "40px" }}></span>

                        {/* Loader skeletons for chips */}
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={40}
                            height={15}
                            style={{ borderRadius: 16, marginRight: 8 }}
                        />
                    </Box>
                </div>
            </Box>
        </Box>
    </Box>
</>);

// export default DetailsLoader;

export const deleteAllCartItems = async ({ dispatch, app_state = {}, method = 'DELETE', initialLogin = false }) => {
    if ((app_state?.plrDatesToPush && app_state.plrDatesToPush.length > 0) || initialLogin === true) {
        const payload = {
            asOfDate: app_state.primary_stay_range.as_of_date
        };
        const result = await callApiDirect(app_state, "clearCart", payload, method);
        try {
            const { isSuccess } = result.data;
            if (isSuccess) {
                dispatch({
                    type: "UPDATE_STATE",
                    payload: {
                        app_state: {
                            plrDatesToPush: [],
                        }
                    }
                });
            } else {
                console.error("Error deleting cart.");
            }
            return result;
        } catch (error) {
            console.error("Error deleting cart items:", error);
            throw error;
        }
    }
};
export default SendRestrictionsProductModal;









